import * as React from 'react';
import { Dispatch } from 'redux';
import { ChangePasswordRequest as IChangePasswordRequest, UserViewModel } from 'stageclip-common';

import { ChangePasswordFormData } from '../../models/changePasswordFormData';
import { BaseApiPatchRequest } from '../generic/baseApiPatchRequest';
import * as EntityNormalizers from '../normalizers/entityNormalizers';
import * as UserNormalizers from '../normalizers/userNormalizers';

export class ChangePasswordRequest extends BaseApiPatchRequest<
  IChangePasswordRequest,
  EntityNormalizers.NormalizedSingleEntity<UserNormalizers.NormalizedUsers<UserViewModel>>
> {
  constructor(
    userId: string,
    changePasswordFormData: ChangePasswordFormData,
    component: React.Component,
    dispatch: Dispatch,
  ) {
    super({ ...changePasswordFormData, userId: undefined, confirmNewPassword: undefined }, component, dispatch);
    this.path = `/users/${userId}/change-password`;
    this.normalizeMethod = UserNormalizers.normalizeSingleUser;
  }
}
